import React from 'react';
import { Prompt } from 'react-router';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { deleteProject, setTemporaryProject } from '../../actions';
import { withTranslation } from 'react-i18next';

class Handler extends React.Component {

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {

            if (prevProps.isTemporary
                && (prevProps.location.pathname.endsWith("driver") || prevProps.location.pathname.endsWith("summary"))
                && (!this.props.location.pathname.endsWith("driver") && !this.props.location.pathname.endsWith("summary"))) {

                this.props.deleteProject(prevProps.project.id);
                this.props.setTemporaryProject(false);
            }
        }
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <Prompt
                    when={this.props.isTemporary && (this.props.location.pathname.endsWith("driver") || this.props.location.pathname.endsWith("summary"))}
                    message={location =>
                        this.props.isTemporary && !location.pathname.endsWith("driver") && !location.pathname.endsWith("summary")
                            ? t("Unsaved_Project_Warning")
                            : true}
                />
                {this.props.children}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        project: state.project.info,
        isTemporary: state.project.isTemporary
    };
};

const mapDispatchToProps = {
    deleteProject,
    setTemporaryProject
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(Handler)));
